import { createRouter, createWebHistory } from 'vue-router'
import {
  checkLocalTermsAcceptanceStatus,
  tokenIsValid,
  getAuthUser,
} from '../services/auth'
import { getUserById } from '../services/users'
import { CATEGORIES } from '../services/posts'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: 'Inicia Sesión en Miib',
    },
  },
  {
    path: '/reset',
    name: 'Reset Password',
    component: () => import('../views/Reset.vue'),
    meta: {
      title: 'Restablecer Contraseña',
    },
  },
  {
    path: '/forgot-password',
    name: 'Olvidé mi contraseña',
    component: () => import('../views/Forgot.vue'),
    meta: {
      title: 'Olvidé mi contraseña',
    },
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: () => import('../views/404.vue'),
    meta: {
      title: 'Página no encontrada',
    },
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: 'Bienvenido a miib',
      requiresAuth: true,
    },
  },
  {
    path: '/posts/category/:category',
    name: 'Category',
    component: () => import('../views/Home.vue'),
    meta: {
      title: 'Bienvenido a miib',
      requiresAuth: true,
    },
  },
  {
    path: '/posts/user/:id',
    name: 'UserPosts',
    component: () => import('../views/Home.vue'),
    meta: {
      title: 'Publicaciones de Usuario',
      requiresAuth: true,
    },
  },
  {
    path: '/posts/:id',
    name: 'Post',
    component: () => import('../views/Home.vue'),
    meta: {
      title: 'Publicación',
      requiresAuth: true,
    },
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('../views/Home.vue'),
    meta: {
      title: 'Términos y Condiciones',
    },
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('../views/Privacy.vue'),
    meta: {
      title: 'Políticas de privacidad',
    },
  },
  {
    path: '/components',
    name: 'Components',
    component: () => import('../views/Components.vue'),
    meta: {
      title: 'Componentes',
      requiresAuth: true,
    },
  },
  {
    path: '/no-network',
    name: 'NoNetwork',
    component: () => import('../views/NoNetwork.vue'),
    meta: {
      title: 'Sin conexión',
    },
  },
  {
    path: '/bugsnag',
    name: 'BugsnagTest',
    component: () => import('../views/BugsnagTest.vue'),
    meta: {
      title: 'Prueba de Bugsnag',
    },
  },
]

const router = new createRouter({
  history: createWebHistory(),
  routes,
})

router.afterEach(async (to, from) => {
  if (to.path.includes('/category/')) {
    switch (to.params.category) {
      case CATEGORIES[0]:
        document.title = 'Posts populares'
        break
      case CATEGORIES[1]:
        document.title = 'Posts destacados'
        break
      case CATEGORIES[2]:
        document.title = 'Publicaciones pastorales'
        break
      default:
        return 'Bienvenido a miib'
    }
    return
  } else if (to.path.includes('/user/')) {
    const isCurrentUser = to.params.id == getAuthUser().ID
    if (isCurrentUser) {
      document.title = 'Mis posts'
      return
    } else {
      await getUserById(to.params.id).then(
        user => (document.title = `Publicaciones de ${user.user_display_name}`)
      )
      return
    }
  }

  document.title = to.meta.title
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('token')
    const user = JSON.parse(localStorage.getItem('user'))
    if (tokenIsValid(token, user)) {
      if (!(await checkLocalTermsAcceptanceStatus()) && to.name !== 'Terms') {
        next('/terms')
        return
      }
      next()
      return
    }
    next('/login')
    return
  }
  next()
})

export default router
